export const Logo = () => {
  return (
    <div className="flex whitespace-nowrap leading-none relative text-sm md:text-base lg:text-lg xl:text-2xl">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-symbol="baselstab"
        className="mt-[0.18em] text-[0.59em] w-[1em] h-[1.7em]"
      >
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34" fill="none" id="-4Y9wRLOlvmlUIQBr5IEC">
          <path
            d="M7.49659 17.8916H16.8848C17.1201 21.1464 19.9476 33.8162 19.9476 33.8162C19.9476 33.8162 16.677 30.8899 15.1848 29.3179C14.3535 30.8899 12.2593 33.8162 12.2593 33.8162C12.2593 33.8162 10.1064 30.8536 9.19463 29.3179C7.59659 30.9262 4.43188 33.8162 4.43188 33.8162C4.43188 33.8162 7.26522 20.751 7.49463 17.8916H7.49659Z"
            fill="currentColor"
          ></path>
          <path
            d="M4.71426 11.0152C2.35936 11.4717 -0.16417 9.64565 0.0083787 6.47868C0.180928 3.31172 2.89661 0.610817 6.47897 0.083626C9.62799 -0.380531 13.2241 1.07879 14.8594 4.67936C15.879 6.92756 15.8731 9.30374 16.2456 11.699H8.48093C8.59661 11.2196 8.91426 9.8634 9.0025 8.55497C9.17701 5.95722 7.24956 4.55902 5.61426 4.7443C4.09857 4.91621 3.26328 5.98014 3.2123 6.96385C3.18289 7.54452 3.45152 8.31621 4.17505 8.39071C4.60642 8.43655 5.03975 8.1252 5.06916 7.72025C5.09269 7.3879 4.76916 7.08801 4.51034 7.08801C4.29857 7.08801 4.15348 7.25992 4.03387 7.4261C3.88093 7.0307 4.30054 5.96677 5.33387 5.91329C6.2574 5.86554 7.27897 6.70217 7.36132 7.88261C7.47112 9.44891 6.3672 10.6962 4.71426 11.0152Z"
            fill="currentColor"
          ></path>
          <path
            d="M17.6084 16.1744H7.07706C6.74373 16.1744 6.4751 16.4361 6.4751 16.7608C6.4751 17.0856 6.80059 17.3472 7.13196 17.3472H17.5516C17.8849 17.3472 18.2084 17.0856 18.2084 16.7608C18.2084 16.4361 17.9398 16.1744 17.6065 16.1744H17.6084Z"
            fill="currentColor"
          ></path>
          <path
            d="M16.9514 12.2167H7.422C7.08867 12.2167 6.76514 12.4784 6.76514 12.8031C6.76514 13.1278 7.03376 13.3895 7.3671 13.3895H17.0063C17.3396 13.3895 17.6083 13.1278 17.6083 12.8031C17.6083 12.4784 17.2828 12.2167 16.9514 12.2167Z"
            fill="currentColor"
          ></path>
          <path
            d="M18.2712 13.8766H6.37315C5.87119 13.8766 5.40845 14.272 5.40845 14.761C5.40845 15.25 5.87119 15.6454 6.37315 15.6454H18.2712C18.7732 15.6454 19.2359 15.25 19.2359 14.761C19.2359 14.272 18.7732 13.8766 18.2712 13.8766Z"
            fill="currentColor"
          ></path>
        </symbol>
        <use href="#-4Y9wRLOlvmlUIQBr5IEC"></use>
      </svg>
      <span className="h-[1.2083em] ml-[0.3em] pl-[0.25em] leading-[1.2em] border-l border-gray-900 font-bold">
        Kanton Basel-Stadt
      </span>
    </div>
  )
}
